// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__pPoGs","signatureBlock":"Footer_signatureBlock__1JkBQ","signature":"Footer_signature__u8QzF"};